// test routes, comment it when making real routes ---

import { createRouter, createWebHistory } from 'vue-router'
/* import User from '@/test/user/User'
import Auth from '@/test/user/Auth'
import Friendship from '@/test/friendship/Friendship.vue'
import StatusTest from '@/test/status/Status.vue'
import Notification from '@/test/notification/Notification.vue'
import Chat from '@/test/chat/Chat.vue'
import Publication from '@/test/publication/Publication.vue'
import PublicationComment from '@/test/publication/Comment.vue'
import Conference from '../test/conference/Conference.vue'
import ConferenceComment from '../test/conference/Comment.vue' */
// real routes ---------------------------
import Login from '@/views/login/Login.vue'
import Profile from '@/views/profile/Profile.vue'
import BirthInfos from '@/views/birthInfos/BirthInfos.vue'
import PlayLists from '@/views/playLists/PlayLists.vue'
import HomeView from '@/views/home/HomeView.vue'
import Status1 from '@/views/status/Status.vue'
import ShowConversation from '@/views/conversation/ShowConversation.vue'
import ChatMessage from '@/views/chat/Chat.vue'
import Publications from '../views/publications/Publications.vue'
import LiveRoom from '@/views/conference/LiveRoom.vue'
import PubRedirect from '@/views/publications/PubRedirect.vue'
import ConfRedirect from '@/views/conference/ConfRedirect.vue'

const routes = [
 /*  {
    path: '/user',
    name: 'user',
    component: User
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth
  },
  {
    path: '/auth/:token',
    name: 'authToken',
    component: Auth
  },
  {
    path: '/friendship',
    name: 'friendship',
    component: Friendship
  },
  {
    path: '/statustest',
    name: 'statustest',
    component: StatusTest
  },  
  {
    path: '/notification',
    name: 'notification',
    component: Notification
  },
  {
    path: '/chat',
    name: 'chat',
    component: Chat
  },
  {
    path: '/publication',
    name: 'publication',
    component: Publication
  },
  {
    path: '/publicationComment',
    name: 'publicationComment',
    component: PublicationComment
  },
  {
    path: '/conference',
    name: 'conference',
    component: Conference
  },
  {
    path: '/conferenceComment',
    name: 'conferenceComment',
    component: ConferenceComment
  }, */
  // real routes ---------------------------
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/profile/:uid',
    name: 'profile',
    component: Profile
  },
  {
    path: '/birthInfos/:token/:isUserExist/:uid',
    name: 'birthInfos',
    component: BirthInfos
  },
  {
    path: '/playLists',
    name: 'playLists',
    component: PlayLists
  },
/*   {
    path: '/',
    name: 'home',
    component: Home
  }, */
  { path: '/home', name:'home', component: HomeView },
  {
    path: '/status',
    name: 'status',
    component: Status1
  },
  {
    path: '/inbox',
    name: 'inbox',
    component: ShowConversation
  },
  {
    path: '/chatMessage',
    name: 'chatMessage',
    component: ChatMessage
  },
  {
    path: '/publications',
    name: 'publications',
    component: Publications
  },
  {
    path: '/liveroom',
    name: 'liveroom',
    component: LiveRoom
  },
  { path: '/publication/:id', component: PubRedirect },
  { path: '/conference/:id', component: ConfRedirect }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
